import React from "react";
import styled from "styled-components";
import { useAuthUserContext } from "../../../../context/AdministratorContextProvider";
import { CompanyActivityLogSection } from "../components/CompanyActivityLogSection";
import { CompanyNotesTab } from "../components/CompanyNotesTab";
import CompanyInfo from "../components/Details";
import { FullCompanyApiType } from "../../../../util/types";

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

interface CompanyOverviewSectionProps {
  companyId: string;
  data: FullCompanyApiType | undefined;
  onCompanySaved: (company: FullCompanyApiType) => void;
  onVerifyClick: () => Promise<void>;
  onVerificationRejectClick: () => Promise<void>;
  onActivateClick: () => Promise<void>;
  onBanClick: () => Promise<void>;
  onEnableStripePaymentClick: () => Promise<void>;
  onDisableStripePaymentClick: () => Promise<void>;
  onRefresh: () => void;
  partnersErrors?: string[];
  onMarkAsPartnerClick?: () => void;
}

export const CompanyOverviewSection: React.FunctionComponent<
  CompanyOverviewSectionProps
> = ({ companyId, ...companyInfoProps }) => {
  const { authUser } = useAuthUserContext();
  const canViewAdministratorLogs = Boolean(
    authUser?.policies?.viewAdministrators
  );

  return (
    <Stack>
      <CompanyInfo {...companyInfoProps} />
      <CompanyNotesTab companyId={companyId} />
      {canViewAdministratorLogs && (
        <CompanyActivityLogSection companyId={companyId} />
      )}
    </Stack>
  );
};
